<template>
    <activation-brief-networks-faq-provider
        v-slot="{
            brief,
            step,
            goNextStep,
            goPreviousStep,
        }"
        style="height: 100%">
        <activation-brief-networks-faq-view
            :brief="brief"
            :step="step"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
        />
    </activation-brief-networks-faq-provider>
</template>

<script>
    import ActivationBriefNetworksFaqView from '../data-views/activation-briefs/ActivationBriefNetworksFaqView';
    import ActivationBriefNetworksFaqProvider from '../providers/activation-brief-steps/ActivationBriefNetworksFaqProvider';

    export default {
        name:       'ActivationBriefNetworksFaqRouterView',
        components: {
            ActivationBriefNetworksFaqProvider,
            ActivationBriefNetworksFaqView,
        },
    };
</script>
